//shared/components/chat/chatHeader.js
import {
  Paper,
  Box,
  Avatar,
  Typography,
  IconButton,
  Tooltip,
} from "@mui/material";

import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

const ChatHeader = ({ user, isAI, onClearHistory }) => {
  return (
    <Paper
      sx={{
        p: 2,
        borderBottom: 1,
        borderColor: "divider",
        display: "flex",
        alignItems: "center",
        gap: 2,
      }}
      elevation={0}
    >
      {isAI ? (
        <Avatar
          sx={{
            bgcolor: "#ccc",
            padding: "3px",
            "& img": {
              objectFit: "contain",
              imageRendering: "auto",
            },
          }}
          src="/images/dentinhoCutNoBg.png"
        >
          Dentinho
        </Avatar>
      ) : (
        <Avatar
          src={
            user?.avatar
              ? `${process.env.REACT_APP_BACKEND_LINK}/${user.avatar}`
              : null
          }
        >
          {user?.name?.[0]?.toUpperCase()}
        </Avatar>
      )}
      <Box sx={{ flex: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="h6">{user?.name || "Utilizador"}</Typography>
        </Box>
        <Typography variant="caption" color="text.secondary">
          {isAI ? "Sou o Assistente IA da odontoHT" : user?.role || ""}
        </Typography>
      </Box>
      {isAI && onClearHistory && (
        <Tooltip title="Limpar histórico">
          <IconButton onClick={onClearHistory} size="small" color="error">
            <DeleteOutlineIcon />
          </IconButton>
        </Tooltip>
      )}
    </Paper>
  );
};

export default ChatHeader;
